<template>
  <div class="pt-4">
    <!-- <Logo /> -->
    <div class="px-8 pt-4">
      <Header />
    </div>
    <div v-if="$store.state.isSearch">
      <Search class="mt-6 px-8" />
    </div>
    <div v-else-if="$route.path === '/settings'">
      <Settings />
    </div>
    <div v-else>
      <Selected
        class="mt-6 px-8"
        :key="$store.state.selected.ligne + $store.state.selected.stations[0]"
      />
      <Infos class="mt-4" size="medium" :news="true" />
      <Next class="mt-4 px-8" />
      <!-- Share -->
      <div
        class="w-full inline-flex flex-row-reverse sticky"
        v-if="navigatorShare"
      >
        <img
          src="/images/share.svg"
          style="height: auto; width: 35px; margin-top: -8rem;"
          class="mr-2"
          @click="shareLink()"
        />
      </div>
      <HomeSearchHilight />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Search from "@/components/Search.vue";
import Selected from "@/components/Selected.vue";
import Infos from "@/components/Infos.vue";
import Settings from "@/components/Settings.vue";
import Next from "@/components/Next.vue";
import HomeSearchHilight from "@/components/HomeSearchHilight.vue";

import { exist, ligneExist, arretExist } from "@/exist.js";

export default {
  name: "home",
  components: {
    Header,
    Search,
    Selected,
    Settings,
    Infos,
    Next,
    HomeSearchHilight
  },
  data() {
    return {
      navigatorShare: false,
      default: {
        id: "11821953316814895",
        url: "les-vergnes-la-pardieu-gare",
        ligne: "A",
        stations: ["Jaude"],
        direction: {
          a: "Les Vergnes",
          r: "La Pardieu Gare"
        },
        selected: "a"
      },
      polling: null
    };
  },
  methods: {
    pollData() {
      this.polling = setInterval(() => {
        this.$store.dispatch("call");
      }, 3000);
    },
    setLastSearch(selected) {
      console.log("Load lastsearch from localStorage");
      let lastSearched = JSON.parse(localStorage.getItem("lastSearch")) || [];

      if (selected) {
        const ids = lastSearched.map(item => item.id);
        lastSearched.splice(ids.indexOf(selected.id), 1);
      }

      this.$store.commit("setLastSearch", lastSearched || [selected]);
    },
    shareLink() {
      if (navigator.share) {
        const ligne = this.$store.state.selected.ligne;
        const direction = this.$store.state.selected.direction[
          this.$store.state.selected.selected
        ];
        const station = this.$store.state.selected.stations[0];
        const item = ligne == "A" ? "tram" : `bus ${ligne}`;

        navigator.share({
          title: `Partage les horaires du ${item}`,
          text: `Les horaires du ${item} à ${station} direction ${direction}`,
          url: `https://t2c.app/${ligne}/${station}/${direction}`
        });
      }
    },
    searchLigne(params) {
      const { ligne } = this.$route.params;

      if (!ligneExist(ligne)) {
        return this.shareHome(null);
      }

      this.$store.commit("selectLineFilter", ligne);
      this.$store.commit("startSearch");
    },
    searchArret(params) {
      const { arret } = this.$route.params;

      if (!arretExist(arret)) {
        return this.shareHome(null);
      }

      this.$store.commit("search", arret);
    },
    shareHome(params) {
      const { ligne, arret, direction } = params || {
        ligne: null,
        arret: null,
        direction: null
      };
      let selected = null;

      if (ligne && arret && direction) {
        console.log("Load from share");
        const foundFromShare = exist(ligne, arret, direction);
        selected = foundFromShare;
      } else if (localStorage.getItem("selected")) {
        console.log("Load from storage");
        selected = JSON.parse(localStorage.getItem("selected"));
      } else {
        console.log("Load default");
        selected = this.default;
      }
      if (localStorage.getItem("selected") && !selected) {
        console.log("Load from storage, no selected");
        selected = JSON.parse(localStorage.getItem("selected"));
      }

      if (localStorage.getItem("lastSearch")) {
        const lastSearch = JSON.parse(localStorage.getItem("lastSearch")) || [];
        console.log({ lastSearch });
        if (lastSearch.length) {
          this.setLastSearch(lastSearch);
        }
      }

      this.$store.commit("select", selected);
      this.$store.dispatch("call");
    }
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  created() {
    this.pollData();
  },
  mounted() {
    console.log("Home");

    const format = localStorage.getItem("selectedTimeFormat");
    if (format) {
      this.$store.commit("selectTimeFormat", format);
    }

    this.navigatorShare = Boolean(navigator.share);
    switch (this.$route.name) {
      case "searchLigne":
        console.log(`searchLigne`, this.$route.params);
        this.searchLigne(this.$route.params);
        break;

      case "searchArret":
        console.log(`searchArret`, this.$route.params);
        this.searchArret(this.$route.params);
        break;

      case "shareHome":
        console.log(`shareHome`, this.$route.params);
        this.shareHome(this.$route.params);
        break;

      default:
        console.log(`Default`, this.$route.params);
        this.shareHome(this.$route.params);
        break;
    }
    this.$store.dispatch("infos");
  }
};
</script>
